module.exports = __webpack_public_path__ + "static/kanit-700-2cb8a30a6579052857bc49d33efa39be.woff2";